import gsap from "gsap";
export default class Label {
  constructor (element) {
    this.element = element;

    const [x, y] = this.element.dataset.position.split(",")

    gsap.set(this.element, { left: `${x}%`, top: `${y}%` });
  }
}